// Generated by CoffeeScript 2.7.0
var ImportCascadedSelectsModal;

import Modal from 'trunks/vue/admin/components/modals/modal.js';

import ResponseImportModelModal from 'trunks/vue/admin/compositions/response_import/response_import_model.js';

import ResponseImportModalMixin from 'trunks/vue/admin/compositions/response_import/response_import_modal_mixin.js';

import {
  newSpinner
} from 'trunks/vue/admin/components/spinner.js';

export default ImportCascadedSelectsModal = Vue.extend({
  mixins: [ResponseImportModalMixin],
  components: {
    'modal': Modal,
    'import-model-modal': ResponseImportModelModal
  },
  data: function() {
    return {
      cascadedSelectName: '',
      valid: true
    };
  },
  template: `<modal title="导入级联选择"
       extendClass="responses-import-modal cascaded-select-import-modal"
       ref="modal">
  <import-model-modal :uploadRequest='uploadRequest'
                      :requestError='requestError'
                      :requestSuccess='requestSuccess'
                      :file='file'
                      @closeUploadMask='closeUploadMaskFunc'
                      @removeFile='removeFileFunc'>
    <template slot="modalField">
      <div :class="{ 'has-error': !valid }"
           class="form-field mt-5 required">
        <div class="form-field-head mr-2">
          <div class="form-field-title">级联选择名称</div>
        </div>
        <div class="form-field-input-container">
          <div class="form-field-input">
            <input v-model.trim="cascadedSelectName"
                   class="form-field-value"
                   placeholder="请输入级联选择名称"
                   type="text">
          </div>
          <div class="message">不能为空</div>
        </div>
      </div>
    </template>

    <template slot="importRecords">
      <a href="/admin/import_records?type=CreateCascadedSelect"
         class="btn-link gray-text ml-1 mr-1">导入记录-导入填写记录</a>
    </template>

    <template slot="fileUpload">
      <input type="file"
             accept=".xlsx"
             hidden='true'
             @change='filesChangedFunc'
             ref="uploadInput"/>
    </template>
    
    <template slot="downloadTemplate">
      <a href="/downloads/级联选择导入模板.xlsx"
         class="gray-link" target="_blank"
         download="级联选择导入模板.xlsx">点击下载导入模板</a>
    </template>
  </import-model-modal>
  <div class="modal-footer" slot='footer'>
    <button :disabled="requestSuccess"
            class="outlined btn-default"
            @click='cancel'>取消</button>
    <button :disabled="buttonDisabled"
            @click='ensure("ImportRecord::CreateCascadedSelect")'>确定</button>
  </div>
</modal>`,
  methods: {
    ensure: function(type) {
      this._validate();
      if (!this.valid) {
        return;
      }
      if (this.requestSuccess) {
        return location.reload();
      } else {
        return this.importFile(type);
      }
    },
    doRequest: function(id, type) {
      var data;
      data = {
        options: {
          name: this.cascadedSelectName
        },
        type: type,
        attachment_id: id
      };
      return Skylark.Libs.Ajax.post("/admin/import_records", {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        data: data,
        success: () => {
          this.requestSuccess = true;
          return this.requestError = false;
        },
        error: function(xhr, status, error) {
          var text;
          text = error.error ? error.error : "导入失败";
          return Skylark.Bridge.newAlertify(text, {
            type: 'error'
          });
        }
      });
    },
    _validate: function() {
      return this.valid = Boolean(this.cascadedSelectName);
    }
  }
});
